import React from "react";
import { Link } from "react-router-dom";
import { FREE_ASSESSMENT_URL } from "../../../constants/journey";
import { C, FONT } from "../../../constants/mq";

// Two sand boxes with one button each, like "Find your course / Search now"
// on mq.edu.au. The assessment box goes to the assessment start page (it
// used to send new families to the student login).

const css = `
.cs-boxes { display: grid; grid-template-columns: 1fr 1fr; gap: 26px; }
.cs-box { display: flex; align-items: center; justify-content: space-between; gap: 20px; padding: 26px 26px; }
.cs-box h2 { font-size: 17px; font-weight: 700; color: ${C.ink}; margin: 0; line-height: 1.4; }
.cs-box p { font-size: 13px; color: ${C.muted}; margin: 4px 0 0; line-height: 1.5; }
.cs-box .mq-btn { min-width: 210px; }
@media (max-width: 900px) {
  .cs-boxes { grid-template-columns: 1fr; }
}
@media (max-width: 520px) {
  .cs-box { flex-direction: column; align-items: flex-start; }
  .cs-box .mq-btn { width: 100%; min-width: 0; }
}
`;

// `flush` drops the top padding where the boxes sit straight under the
// course finder (home page).
function FreeAssessment({ flush = false }) {
  return (
    <section style={{ background: "#ffffff", padding: flush ? "0 0 72px" : "56px 0 72px", fontFamily: FONT }}>
      <style>{css}</style>
      <div style={{ maxWidth: 1072, margin: "0 auto", padding: "0 24px" }}>
        <div className="cs-boxes">
          <div className="mq-sand cs-box">
            <div>
              <h2>Take a free assessment</h2>
              <p>Find the right level before the first lesson.</p>
            </div>
            <a
              className="mq-btn"
              href={FREE_ASSESSMENT_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              Book now
            </a>
          </div>
          <div className="mq-sand cs-box">
            <div>
              <h2>Fees for this term</h2>
              <p>Per-lesson prices, materials and discounts.</p>
            </div>
            <Link className="mq-btn" to="/pricing">
              View pricing
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}

export default FreeAssessment;
